import { generatePath } from "react-router-dom";
import Link from "./Link";

export default class TaMerchantLink extends Link {
  constructor(merchantId, name, icon, path, component, authenticationName, taMerchantId) {
    super(merchantId, name, icon, path, component, authenticationName);
    this.taMerchantId = taMerchantId;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId, taMerchantId: this.taMerchantId });
  }
}
